export async function getList({commit}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.metaGroups.index();
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function createMetaGroup({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.metaGroups.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updateMetaGroup({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.metaGroups.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function deleteMetaGroupById({commit}, payload) {
  const response = await this.$adminRepositories.metaGroups.delete(payload.id);
  await commit('removeItem', payload.index);
  return response;
}

export async function findMetaGroupById({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.metaGroups.show(payload);
  if (!errResponse && responseData.success) {
    return commit('setItem', responseData.data);
  }

  return {};
}
